import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './AddExpenseButton.module.css';
import TrackSpendingModal from './TrackSpendingModal';
import { createManualTransaction } from '../services/transactionService';

const AddExpenseButton: React.FC = () => {
  const [showAddExpenseModal, setShowAddExpenseModal] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // Don't show the button on login/register pages
  const hiddenPaths = ['/login', '/register', '/forgot-password', '/reset-password'];
  if (hiddenPaths.includes(location.pathname)) {
    return null;
  }

  const handleAddExpenseClick = () => {
    setShowAddExpenseModal(true);
  };

  const handleExpenseComplete = async (amount: number, category?: string, description?: string) => {
    try {
      console.log('===== AddExpenseButton: handleExpenseComplete CALLED =====');
      console.log('AddExpenseButton: Current location:', location.pathname);
      console.log('AddExpenseButton: Expense details:', { amount, category, description });

      // 1. Create the transaction - save to database
      console.log('AddExpenseButton: Calling createManualTransaction...');
      const result = await createManualTransaction(amount, category || 'Want', description || 'Manual Expense');
      console.log('AddExpenseButton: Transaction created successfully, result:', result);

      // 2. DON'T close modal - let the AddExpenseModal handle closing after showing XP and Plaid prompt
      // setShowAddExpenseModal(false); // REMOVED - modal will close itself when user clicks "Skip" or connects Plaid
      console.log('AddExpenseButton: Letting modal handle its own close after showing XP and Plaid prompt');

      // 3. Set localStorage flag for HomePage to refresh (works reliably on iOS)
      localStorage.setItem('needsTransactionRefresh', 'true');
      console.log('AddExpenseButton: Set needsTransactionRefresh flag in localStorage');

      // 4. Always dispatch event as backup (for web and if HomePage is already listening)
      window.dispatchEvent(new Event('manualTransactionAdded'));
      console.log('AddExpenseButton: Dispatched manualTransactionAdded event');

      // 5. REMOVED - Don't navigate away while modal is showing XP animation and Plaid prompt
      // The modal will close itself, then we can navigate if needed
      // setTimeout(() => {
      //   const timestamp = Date.now();
      //   console.log('AddExpenseButton: Navigating to /home with timestamp:', timestamp);
      //   navigate(`/home?refresh=${timestamp}`, { replace: false });
      // }, 200);

      console.log('===== AddExpenseButton: handleExpenseComplete COMPLETED =====');
    } catch (error) {
      console.error('===== AddExpenseButton: ERROR in handleExpenseComplete =====');
      console.error('AddExpenseButton: Error details:', error);
      alert('Failed to save expense. Please try again.');
      setShowAddExpenseModal(false);
    }
  };

  // Add handler for when modal actually closes (after user dismisses it)
  const handleModalCloseComplete = () => {
    setShowAddExpenseModal(false);
    // Navigate to home with refresh after modal is fully closed
    setTimeout(() => {
      const timestamp = Date.now();
      console.log('AddExpenseButton: Modal closed, navigating to /home with timestamp:', timestamp);
      navigate(`/home?refresh=${timestamp}`, { replace: false });
    }, 100);
  };

  return (
    <>
      <button
        className={styles.addExpenseButton}
        onClick={handleAddExpenseClick}
        aria-label="Add Expense"
      >
        <span className={styles.addExpenseIcon}>+</span>
        <span className={styles.addExpenseLabel}>Add Expense</span>
      </button>

      <TrackSpendingModal
        isOpen={showAddExpenseModal}
        onClose={handleModalCloseComplete}
        onComplete={handleExpenseComplete}
      />
    </>
  );
};

export default AddExpenseButton;
